import React, { useState, useEffect } from "react";
import { api } from "@/auth/AuthContext";
import { Card } from "@/components/ui-kit";
import { Receipt } from "@phosphor-icons/react";

const fmtDate = (iso, lang) => {
  try { return new Date(iso).toLocaleDateString(lang === "cs" ? "cs-CZ" : "en-US", { day: "numeric", month: "numeric", year: "numeric" }); }
  catch { return iso?.slice(0, 10) || "—"; }
};

export const PaymentHistory = ({ lang }) => {
  const cs = lang === "cs";
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/billing/history").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <Card className="p-6 space-y-4" data-testid="payment-history-card">
      <h3 className="text-lg font-medium text-zinc-100 flex items-center gap-2">
        <Receipt weight="bold" size={18} className="text-amber-400" />
        {cs ? "Historie plateb" : "Payment history"}
      </h3>
      {items === null ? (
        <div className="text-sm text-zinc-500">…</div>
      ) : items.length === 0 ? (
        <p className="text-sm text-zinc-500" data-testid="payment-history-empty">
          {cs ? "Zatím žádné platby. Historie se zobrazí po prvním nákupu předplatného." : "No payments yet. History appears after your first subscription purchase."}
        </p>
      ) : (
        <div className="divide-y divide-zinc-900" data-testid="payment-history-list">
          {items.map((p, i) => (
            <div key={i} className="flex items-center justify-between py-2.5 gap-3" data-testid={`payment-history-row-${i}`}>
              <div className="min-w-0">
                <span className="text-sm font-mono font-medium text-zinc-100">{p.plan}</span>
                <span className="text-xs text-zinc-500 ml-2">{p.source === "google_play" ? "Google Play" : "Stripe"}</span>
              </div>
              <div className="text-right shrink-0">
                <div className="text-sm font-mono text-zinc-100">{p.amount.toLocaleString(cs ? "cs-CZ" : "en-US")} {p.currency === "CZK" ? "Kč" : p.currency}</div>
                <div className="text-xs text-zinc-500 font-mono">{fmtDate(p.date, lang)}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
